import { Injectable } from '@angular/core';

import {
  AspectOrientedConfigService,
  IndifferentConfigService,
} from '@alfresco/adf-content-services';
import {
  AspectOrientedConfig,
  ContentMetadataConfig,
  LayoutOrientedConfig,
  PresetConfig,
} from '@alfresco/adf-content-services/lib/content-metadata/interfaces/content-metadata.interfaces';

import { WkLayoutOrientedConfigService } from './wk-layout-oriented-config.service';
import { WkAppConfigService } from './wk-app-config.service';
import { WkAlfrescoApplicationService } from './wk-alfresco-application.service';

@Injectable({
  providedIn: 'root',
})
export class WkContentMetadataConfigFactory {
  static readonly INDIFFERENT_PRESET = '*';
  static readonly DEFAULT_PRESET_NAME = 'default';

  constructor(
    private readonly wkAppConfigService: WkAppConfigService,
    private readonly wkAppService: WkAlfrescoApplicationService
  ) {}

  public get(presetName = 'default'): ContentMetadataConfig {
    let presetConfig: PresetConfig;
    try {
      presetConfig =
        this.wkAppConfigService.config['content-metadata'].presets[presetName];
    } catch {
      if (presetName !== WkContentMetadataConfigFactory.DEFAULT_PRESET_NAME) {
        this.wkAppService.logInstance.error(
          `No content-metadata preset for: ${presetName}`
        );
      }
      presetConfig = WkContentMetadataConfigFactory.INDIFFERENT_PRESET;
    }

    return this.createConfig(presetConfig);
  }

  private createConfig(presetConfig: PresetConfig): ContentMetadataConfig {
    let config: ContentMetadataConfig;

    if (this.isLayoutOrientedPreset(presetConfig)) {
      config = new WkLayoutOrientedConfigService(
        presetConfig as LayoutOrientedConfig
      );
    } else if (this.isAspectOrientedPreset(presetConfig)) {
      config = new AspectOrientedConfigService(
        presetConfig as AspectOrientedConfig
      );
    } else {
      config = new IndifferentConfigService();
    }

    Object.freeze(config);
    return config;
  }

  private isAspectOrientedPreset(presetConfig: PresetConfig): boolean {
    return this.isObject(presetConfig);
  }

  private isLayoutOrientedPreset(presetConfig: PresetConfig): boolean {
    return Array.isArray(presetConfig);
  }

  private isObject(x: any): boolean {
    return x != null && typeof x === 'object';
  }
}
